"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableEdge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var types_1 = require("./types");
var clsx_1 = __importDefault(require("clsx"));
var DraggableEdge = function () {
    var _a = (0, react_dnd_1.useDrag)(function () { return ({
        type: types_1.DRAWER_TYPE,
        item: {},
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
    }); }, []), isDragging = _a[0].isDragging, drag = _a[1], preview = _a[2];
    (0, react_1.useEffect)(function () {
        preview((0, react_dnd_html5_backend_1.getEmptyImage)(), { captureDraggingState: true });
    }, []);
    return ((0, jsx_runtime_1.jsx)("button", { className: (0, clsx_1.default)("absolute inset-y-0 right-0 w-6 -mr-6 z-10 border-l-4 outline-none outline-0 focus:outline-none focus:outline-0", isDragging ? "border-lochivar-default" : "hover:border-sorbus-default"), ref: drag }, void 0));
};
exports.DraggableEdge = DraggableEdge;
